import { render, staticRenderFns } from "./_SessionDesignForm.vue?vue&type=template&id=e351f3e8&scoped=true&"
import script from "./_SessionDesignForm.vue?vue&type=script&lang=ts&"
export * from "./_SessionDesignForm.vue?vue&type=script&lang=ts&"
import style0 from "./_SessionDesignForm.vue?vue&type=style&index=0&id=e351f3e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e351f3e8",
  null
  
)

export default component.exports